<template>
    <div class="pro_container">
        <!-- 头部 -->
        <v-header2></v-header2>
        <!-- 产品标题 -->
        <product-tool title="W0" color="#ffffff"></product-tool>
        <!-- 产品图片 -->
        <img class="pro_img" src="../../../assets/img/w0/pc-01.jpg"/>
        <img class="pro_img_mb" src="../../../assets/img/w0/mb-01.jpg"/>
        <!-- 轮播图 -->
        <!-- 产品颜色切换效果 -->
        <div class="pro_animation">
            <swiper :options="swiperOption">
                <!-- slides -->
                <swiper-slide v-for="(item, index) in earphones" :key="index">
                    <div class="pro_animation_item"><img :src="item" /></div>
                </swiper-slide>
                <!-- Optional controls -->
                <div class="swiper-button-prev" slot="button-prev"><i></i></div>
                <div class="swiper-button-next" slot="button-next"><i></i></div>
            </swiper>
        </div>
        <img class="pro_img" style="margin-top: 60px" src="../../../assets/img/w0/pc-02.jpg"/>
        <img class="pro_img_mb" src="../../../assets/img/w0/mb-02.jpg"/>
        <img class="pro_img" src="../../../assets/img/w0/pc-03.jpg"/>
        <img class="pro_img" src="../../../assets/img/w0/pc-04.jpg"/>
        <img class="pro_img" src="../../../assets/img/w0/pc-05.jpg"/>
        <img class="pro_img" src="../../../assets/img/w0/pc-06.jpg"/>
        <img class="pro_img" src="../../../assets/img/w0/pc-07.jpg"/>
        <img class="pro_img" src="../../../assets/img/w0/pc-08.jpg"/>
        <img class="pro_img_mb" src="../../../assets/img/w0/mb-03.jpg"/>
        <img class="pro_img_mb" src="../../../assets/img/w0/mb-04.jpg"/>
        <img class="pro_img_mb" src="../../../assets/img/w0/mb-05.jpg"/>
        <img class="pro_img_mb" src="../../../assets/img/w0/mb-06.jpg"/>
        <img class="pro_img_mb" src="../../../assets/img/w0/mb-07.jpg"/>
        <img class="pro_img_mb" src="../../../assets/img/w0/mb-08.jpg"/>
        <v-footer2></v-footer2>
        <goto-top></goto-top>
    </div>
</template>

<script>
import {
        swiper,
        swiperSlide
    } from 'vue-awesome-swiper'
export default {
    components: {
        swiper,
        swiperSlide
    },
    data(){
        return {
           swiperOption: {
                // notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
                notNextTick: true,
                // swiper configs 所有的配置同swiper官方api配置
                autoplay: 3000,
                grabCursor: true,
                setWrapperSize: true,
                autoHeight: true,
                paginationClickable: true,
                prevButton: '.swiper-button-prev',
                nextButton: '.swiper-button-next',
                loop: true,
                // mousewheelControl : true,
                observeParents: true,
                // if you need use plugins in the swiper, you can config in here like this
                // 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
                debugger: true,
            },
            earphones: [require("../../../assets/img/w0/1.png"), require("../../../assets/img/w0/2.png"), require("../../../assets/img/w0/3.png")],
        }
    },
    methods:{
       
    }
}
</script>
<style scoped>
.pro_animation .swiper-container{
    width: 1000px;
}
.pro_animation .swiper-button-prev, .pro_animation2 .swiper-button-prev, .pro_animation .swiper-button-next, .pro_animation2 .swiper-button-next{
    width: 40px;
    height: 70px;
}
.pro_animation .swiper-button-prev, .pro_animation2 .swiper-button-prev{
    background-image: url(../../../assets/img/arrow_l_2.png);
}
.pro_animation .swiper-button-next, .pro_animation2 .swiper-button-next{
    background-image: url(../../../assets/img/arrow_r_2.png);
}

@media (max-width: 768px) {
    .pro_animation .swiper-container {
        width: 100%;
    }

    .pro_animation .swiper-button-prev, .pro_animation2 .swiper-button-prev, .pro_animation .swiper-button-next, .pro_animation2 .swiper-button-next{
        width: 30px;
        height: 54px;
    }
    
    .pro_animation_item img{
        width: 60%;
        height: auto;
    }
}

</style>



// WEBPACK FOOTER //
// src/pages/products/W/w0.vue